/**
 * Shared GraphQL query strings for AppSync API-key calls. Single source
 * of truth for selection sets — imported by both the runtime hooks
 * (features/packs/queries.ts, features/social/queries.ts) AND the
 * build-time Vite plugin (vite-plugins/preload-pack-images.ts).
 *
 * If a field is added to the underlying schema (amplify/data/resource.ts),
 * add it to the selection set here in ONE place; both consumers pick up
 * the change automatically.
 */

export const LIST_ACTIVE_PACKS_QUERY = `
  query ListActivePacks {
    listActivePacks {
      pack_id
      name
      set_slug
      price_cents
      cards_per_pack
      description
      pack_art_urls
      pack_art_urls_thumb
      pack_art_urls_2x
    }
  }
`;

// $pack_id is GraphQL `ID!` (not `String!`) per the Amplify schema
// declaration `arguments({ pack_id: a.id().required() })` in
// app/amplify/data/resource.ts:533. AppSync strictly enforces this —
// `String!` causes the query to be rejected with a type-mismatch error.
export const GET_PACK_QUERY = `
  query GetPack($pack_id: ID!) {
    getPack(pack_id: $pack_id) {
      pack_id
      name
      set_slug
      price_cents
      cards_per_pack
      description
      pack_art_urls
      pack_art_urls_thumb
      pack_art_urls_2x
    }
  }
`;

export const LIST_RECENT_NOTABLE_PULLS_QUERY = `
  query ListRecentNotablePulls {
    listRecentNotablePulls {
      card_name
      card_image_url
      card_image_url_thumb
      card_image_url_2x
      card_rarity
      market_price_cents
      created_at
      puller_initials
      pack_id
    }
  }
`;
